import React from "react";

const Circle = ({ bg, color, children }) => (
  <strong className={`rounded-circle bg-${bg || "white"}${color ? " text-" + color : ""} px-3 py-2`}>{children}</strong>
);

export default Circle;
